<template>
  <div v-if="nowSys" class="search-box">
    <el-autocomplete
      v-model="state"
      size="samll"
      popper-class="my-autocomplete"
      :fetch-suggestions="querySearch"
      placeholder="请输入菜单关键词"
      clearable
      :trigger-on-focus="false"
      @clear="blurForBug()"
      @select="handleSelect"
    >
      <i slot="suffix" class="el-icon-search el-input__icon" @click="handleIconClick"></i>
      <template slot-scope="{ item }">
        <div class="name">{{ item.name }}</div>
      </template>
    </el-autocomplete>
  </div>
</template>
<script>
import { mapState } from "vuex"
import { treeToArray } from "@/utils"

export default {
  data() {
    return {
      restaurants: [],
      state: ""
    }
  },
  computed: {
    ...mapState("user", ["routes", "nowSys"])
  },
  mounted() {
    this.restaurants = this.loadAll()
  },
  methods: {
    querySearch(queryString, cb) {
      console.log("querySearch", queryString)
      console.log("this.restaurants", this.restaurants)
      var restaurants = this.restaurants
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return restaurant => {
        return restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1
      }
    },
    loadAll() {
      let allMenu = this.routes
      allMenu = treeToArray(allMenu)
      const resMenu = []
      for (let i = 0; i < allMenu.length; i++) {
        const menuListItem = allMenu[i]
        // 非菜单去除
        if (menuListItem.type != 1) {
          allMenu.splice(i, 1)
          i--
        } else {
          // 判断下方list
          // 1、没有list为空或不存在，并且有url，则为可点击菜单
          if ((!menuListItem.list || menuListItem.list.length === 0) && menuListItem.url) {
            resMenu.push(menuListItem)
          }
          // 2、有list 并且里面包含页面类型（2）或者按钮（3）并且有url，则为可点击菜单
          if (menuListItem.list && menuListItem.list.length > 0) {
            const isClickPage = menuListItem.list.filter(listItem => listItem.type == 2 || listItem.type == 3)
            if (isClickPage.length > 0 && menuListItem.url) {
              resMenu.push(menuListItem)
            }
          }
        }
      }
      return resMenu
    },
    // 点击菜单
    handleSelect(item) {
      // 有子元素，则不往下走,直接打开子菜单
      if (item.list && item.list.length > 0) {
        return
      }
      item.fullPath = this.resolvePath(item.url)
      item.meta = {
        title: item.name
      }
      this.$router.push({ path: item.fullPath })
      this.$store.dispatch("tagsView/addView", item)
      // 重制nowSys,让二层菜单隐藏
      this.$store.commit("user/SET_NOWSYS", "")
      // 判断是否是收缩时，点击弹起的，如果是，则再次收缩
      if (this.sidebarFakeClick) {
        this.$store.dispatch("app/toggleSideBar")
      }
    },
    resolvePath(routePath) {
      // 帆软报表暂时处理，后期需要统一在数据中心，进行页面前置
      if (routePath === "https://fr.osa.com/webroot/decision/view/report?viewlet=/流程与IT/帆软广告回本报表.cpt") {
        return "/count#/count/fanruan"
      }
      if (routePath === "https://fr.osa.com/webroot/decision/view/form?viewlet=WCT/数据中心/AB客_裂变销售报表.frm") {
        return "/count#/count/fanruanAB"
      }
      // //权限中心比较特殊，没有作为一个中心上传git，而是和主数据合在一起，所以需要单独判断下
      const isAuthorityCenter = routePath.split("/")?.[1] === "authorityCenter"
      if (isAuthorityCenter) {
        console.log(routePath)
        return "/masterData" + "#" + routePath
      } else {
        return "/" + routePath.split("/")[1] + "#" + routePath
      }
    },
    // 点击clearable清空小图标按钮以后，继续重新在输入框中输入数据，querySearch会触发，但是cb函数不会触发
    // 这样的话就会出现发请求了，也获取数据了，但是input框的输入建议下拉框不呈现在页面上的问题，所以解决方法就是
    // 只要用户点击了
    blurForBug() {
      document.activeElement.blur()
    },
    handleIconClick(ev) {
      console.log(ev)
    }
  }
}
</script>
<style scoped lang="scss">
.search-box {
  position: fixed;
  z-index: 20002;
  left: 74px;
  top: 15px;
}
</style>
<style lang="scss">
.my-autocomplete {
  z-index: 20003 !important;
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>
